//import User from "../../models/User";
import axios from "axios";
import { API_BASE_URL, FETCH_LIMIT } from "./../../globalVars";

export default {
  namespaced: true,

  actions: {
    async hydrate({ commit }, lastUpdateTime = null) {
      const store = this;
      const last = this.getters["entities/settings/query"]().first()
        .lastUpdateFromServer;
      await fetchNext({
        store: store,
        offset: 0,
        lastDateTime: lastUpdateTime ? lastUpdateTime : last ? last : 0
      });
    },

    async createUser(context, user) {
      if (user.isDirty === true) {
        const store = this;
        let response;

        const oldAccount = this.getters["entities/accounts/query"]().first();
        const accountId = oldAccount.id;
        response = await axios({
          method: "post",
          url: API_BASE_URL + `/user`,
          data: {
            accountId: accountId,
            authRoleId: user.authRoleId,
            firstName: user.firstName,
            lastName: user.lastName,
            email: user.email,
            mobilePhoneNumber: user.mobilePhoneNumber,
            roles: user.roles
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`
          }
        }).catch(error => {
          if (error.response.data.message) {
            store.dispatch("entities/settings/update", {
              where: 1,
              data: {
                serverErrorMessage: error.response.data.message
              }
            });
          } else {
            store.dispatch("entities/settings/setIsOffline", true);
          }
        });
        if (response) {
          store.dispatch("entities/users/delete", {
            where: user.tempId
          });
          store.dispatch("entities/users/insert", {
            where: response.id,
            data: response.data
          });
          store.dispatch("entities/settings/setIsOffline", false);
          store.dispatch("entities/settings/update", {
            where: 1,
            data: {
              serverErrorMessage: null
            }
          });
        }
      }
    },

    async updateUser(context, user) {
      const store = this;
      let oldUser = this.getters["entities/users/find"](user.id);
      let response;
      if (
        !(
          oldUser.accountId == user.accountId &&
          oldUser.authRoleId == user.authRoleId &&
          oldUser.firstName == user.firstName &&
          oldUser.lastName == user.lastName &&
          oldUser.email == user.email &&
          oldUser.mobilePhoneNumber == user.mobilePhoneNumber &&
          oldUser.roles == user.roles
        ) ||
        user.isDirty === true
      ) {
        const oldAccount = this.getters["entities/accounts/query"]().first();
        const accountId = oldAccount.id;
        response = await axios({
          method: "patch",
          url: API_BASE_URL + `/user/${user.id}`,
          data: {
            accountId: accountId,
            authRoleId: user.authRoleId,
            firstName: user.firstName,
            lastName: user.lastName,
            email: user.email,
            mobilePhoneNumber: user.mobilePhoneNumber,
            roles: user.roles
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`
          }
        }).catch(error => {
          if (error.response.data.message) {
            store.dispatch("entities/settings/update", {
              where: 1,
              data: {
                serverErrorMessage: error.response.data.message
              }
            });
          } else {
            store.dispatch("entities/settings/setIsOffline", true);
          }
        });
        if (response) {
          store.dispatch("entities/users/update", {
            where: response.id,
            data: response.data
          });
          store.dispatch("entities/settings/setIsOffline", false);
          store.dispatch("entities/settings/update", {
            where: 1,
            data: {
              serverErrorMessage: null
            }
          });
        }
      }
    },

    async deleteUser(context, user) {
      const store = this;
      if (user.isDirty === true) {
        const accountId = this.getters["entities/accounts/query"]().first().id;
        let response = await axios({
          method: "patch",
          url: API_BASE_URL + `/user/${user.id}`,
          data: {
            accountId: accountId,
            id: user.id,
            deleted: true
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`
          }
        }).catch(error => {
          if (error.response.data.message) {
            store.dispatch("entities/settings/update", {
              where: 1,
              data: {
                serverErrorMessage: error.response.data.message
              }
            });
          } else {
            store.dispatch("entities/settings/setIsOffline", true);
          }
        });
        if (response) {
          store.dispatch("entities/users/delete", user.id);
          store.dispatch("entities/settings/setIsOffline", false);
        }
      }
    }
  }
};

async function fetchNext({ store, offset, lastDateTime = 0 }) {
  try {
    let response = await axios({
      method: "get",
      url:
        API_BASE_URL +
        `/user?updatedAt[$gt]=${lastDateTime}&$limit=${FETCH_LIMIT}&$skip=${offset}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`
      }
    });
    const obj = response.data.data;
    const maxRows = response.data.total;
    let users = [];
    obj.forEach(function(user) {
      users.push({
        id: user.id,
        authUid: user.authUid,
        accountId: user.accountId,
        authRoleId: user.authRoleId,
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        mobilePhoneNumber: user.mobilePhoneNumber,
        roles: user.roles,
        isDirty: false,
        createdAt: Date.parse(user.createdAt),
        updatedAt: Date.parse(user.updatedAt)
      });
    });
    if (users.length > 0) {
      store.dispatch("entities/users/insertOrUpdate", {
        data: users
      });
    }
    if (maxRows > FETCH_LIMIT + offset) {
      await fetchNext({
        store,
        offset: FETCH_LIMIT + offset,
        lastDateTime
      });
    }
  } catch (error) {
    if (
      error.response &&
      error.response.data.message == "Access Denied: User Not Authorized"
    ) {
      window.location("/error/not-authorized");
    } else {
      store.dispatch("entities/settings/setIsOffline", true);
    }
  }
}
